import { Injectable, inject } from '@angular/core'
import { IsoDateStr, Quantity, RestClientList } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'

export type ProductivityRecord = {
  id: string
  facilityId: string
  completedAt?: IsoDateStr
  pieceQuantity: number
  itemQuantity: number
  weight: Quantity
  processPlanIds: Set<string>
}

@Injectable({
  providedIn: 'root',
})
export class ProductivityReportService extends RestClientList<ProductivityRecord, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/reports/productivity/', http)
  }
}
